// source: accounts/protos/plan.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */


var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var accounts_protos_plan_dto_pb = require('../../accounts/protos/plan_dto_pb.js');
goog.object.extend(proto, accounts_protos_plan_dto_pb);
goog.exportSymbol('proto.DeleteSubscriptionFirewallRequest', null, global);
goog.exportSymbol('proto.DeleteSubscriptionFirewallResponse', null, global);
goog.exportSymbol('proto.SetPlanFirewallBackendStripe', null, global);
goog.exportSymbol('proto.SetPlanFirewallRequest', null, global);
goog.exportSymbol('proto.SetPlanFirewallRequest.BackendDataCase', null, global);
goog.exportSymbol('proto.SetPlanFirewallRequestBackendType', null, global);
goog.exportSymbol('proto.SetPlanFirewallResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SetPlanFirewallBackendStripe = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.SetPlanFirewallBackendStripe, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SetPlanFirewallBackendStripe.displayName = 'proto.SetPlanFirewallBackendStripe';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SetPlanFirewallRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.SetPlanFirewallRequest.oneofGroups_);
};
goog.inherits(proto.SetPlanFirewallRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SetPlanFirewallRequest.displayName = 'proto.SetPlanFirewallRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SetPlanFirewallResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.SetPlanFirewallResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SetPlanFirewallResponse.displayName = 'proto.SetPlanFirewallResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DeleteSubscriptionFirewallRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DeleteSubscriptionFirewallRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DeleteSubscriptionFirewallRequest.displayName = 'proto.DeleteSubscriptionFirewallRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DeleteSubscriptionFirewallResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DeleteSubscriptionFirewallResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DeleteSubscriptionFirewallResponse.displayName = 'proto.DeleteSubscriptionFirewallResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SetPlanFirewallBackendStripe.prototype.toObject = function(opt_includeInstance) {
  return proto.SetPlanFirewallBackendStripe.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SetPlanFirewallBackendStripe} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SetPlanFirewallBackendStripe.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SetPlanFirewallBackendStripe}
 */
proto.SetPlanFirewallBackendStripe.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SetPlanFirewallBackendStripe;
  return proto.SetPlanFirewallBackendStripe.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SetPlanFirewallBackendStripe} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SetPlanFirewallBackendStripe}
 */
proto.SetPlanFirewallBackendStripe.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SetPlanFirewallBackendStripe.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SetPlanFirewallBackendStripe.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SetPlanFirewallBackendStripe} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SetPlanFirewallBackendStripe.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.SetPlanFirewallRequest.oneofGroups_ = [[6]];

/**
 * @enum {number}
 */
proto.SetPlanFirewallRequest.BackendDataCase = {
  BACKEND_DATA_NOT_SET: 0,
  STRIPE_DATA: 6
};

/**
 * @return {proto.SetPlanFirewallRequest.BackendDataCase}
 */
proto.SetPlanFirewallRequest.prototype.getBackendDataCase = function() {
  return /** @type {proto.SetPlanFirewallRequest.BackendDataCase} */(jspb.Message.computeOneofCase(this, proto.SetPlanFirewallRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SetPlanFirewallRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.SetPlanFirewallRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SetPlanFirewallRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SetPlanFirewallRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    password: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    packageId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    billingId: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    paymentId: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    backendType: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    stripeData: (f = msg.getStripeData()) && proto.SetPlanFirewallBackendStripe.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SetPlanFirewallRequest}
 */
proto.SetPlanFirewallRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SetPlanFirewallRequest;
  return proto.SetPlanFirewallRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SetPlanFirewallRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SetPlanFirewallRequest}
 */
proto.SetPlanFirewallRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPackageId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentId(value);
      break;
    case 5:
      var value = /** @type {!proto.SetPlanFirewallRequestBackendType} */ (reader.readEnum());
      msg.setBackendType(value);
      break;
    case 6:
      var value = new proto.SetPlanFirewallBackendStripe;
      reader.readMessage(value,proto.SetPlanFirewallBackendStripe.deserializeBinaryFromReader);
      msg.setStripeData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SetPlanFirewallRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SetPlanFirewallRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SetPlanFirewallRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SetPlanFirewallRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {!proto.SetPlanFirewallRequestBackendType} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getStripeData();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.SetPlanFirewallBackendStripe.serializeBinaryToWriter
    );
  }
};


/**
 * optional string password = 1;
 * @return {string}
 */
proto.SetPlanFirewallRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SetPlanFirewallRequest} returns this
 */
proto.SetPlanFirewallRequest.prototype.setPassword = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SetPlanFirewallRequest} returns this
 */
proto.SetPlanFirewallRequest.prototype.clearPassword = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SetPlanFirewallRequest.prototype.hasPassword = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string package_id = 2;
 * @return {string}
 */
proto.SetPlanFirewallRequest.prototype.getPackageId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.SetPlanFirewallRequest} returns this
 */
proto.SetPlanFirewallRequest.prototype.setPackageId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SetPlanFirewallRequest} returns this
 */
proto.SetPlanFirewallRequest.prototype.clearPackageId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SetPlanFirewallRequest.prototype.hasPackageId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string billing_id = 3;
 * @return {string}
 */
proto.SetPlanFirewallRequest.prototype.getBillingId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.SetPlanFirewallRequest} returns this
 */
proto.SetPlanFirewallRequest.prototype.setBillingId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SetPlanFirewallRequest} returns this
 */
proto.SetPlanFirewallRequest.prototype.clearBillingId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SetPlanFirewallRequest.prototype.hasBillingId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string payment_id = 4;
 * @return {string}
 */
proto.SetPlanFirewallRequest.prototype.getPaymentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.SetPlanFirewallRequest} returns this
 */
proto.SetPlanFirewallRequest.prototype.setPaymentId = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SetPlanFirewallRequest} returns this
 */
proto.SetPlanFirewallRequest.prototype.clearPaymentId = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SetPlanFirewallRequest.prototype.hasPaymentId = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional SetPlanFirewallRequestBackendType backend_type = 5;
 * @return {!proto.SetPlanFirewallRequestBackendType}
 */
proto.SetPlanFirewallRequest.prototype.getBackendType = function() {
  return /** @type {!proto.SetPlanFirewallRequestBackendType} */ (jspb.Message.getFieldWithDefault(this, 5, 1));
};


/**
 * @param {!proto.SetPlanFirewallRequestBackendType} value
 * @return {!proto.SetPlanFirewallRequest} returns this
 */
proto.SetPlanFirewallRequest.prototype.setBackendType = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SetPlanFirewallRequest} returns this
 */
proto.SetPlanFirewallRequest.prototype.clearBackendType = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SetPlanFirewallRequest.prototype.hasBackendType = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional SetPlanFirewallBackendStripe stripe_data = 6;
 * @return {?proto.SetPlanFirewallBackendStripe}
 */
proto.SetPlanFirewallRequest.prototype.getStripeData = function() {
  return /** @type{?proto.SetPlanFirewallBackendStripe} */ (
    jspb.Message.getWrapperField(this, proto.SetPlanFirewallBackendStripe, 6));
};


/**
 * @param {?proto.SetPlanFirewallBackendStripe|undefined} value
 * @return {!proto.SetPlanFirewallRequest} returns this
*/
proto.SetPlanFirewallRequest.prototype.setStripeData = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.SetPlanFirewallRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SetPlanFirewallRequest} returns this
 */
proto.SetPlanFirewallRequest.prototype.clearStripeData = function() {
  return this.setStripeData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SetPlanFirewallRequest.prototype.hasStripeData = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SetPlanFirewallResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.SetPlanFirewallResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SetPlanFirewallResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SetPlanFirewallResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    statusCode: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    plan: (f = msg.getPlan()) && accounts_protos_plan_dto_pb.PlanFirewallDTO.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SetPlanFirewallResponse}
 */
proto.SetPlanFirewallResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SetPlanFirewallResponse;
  return proto.SetPlanFirewallResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SetPlanFirewallResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SetPlanFirewallResponse}
 */
proto.SetPlanFirewallResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatusCode(value);
      break;
    case 2:
      var value = new accounts_protos_plan_dto_pb.PlanFirewallDTO;
      reader.readMessage(value,accounts_protos_plan_dto_pb.PlanFirewallDTO.deserializeBinaryFromReader);
      msg.setPlan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SetPlanFirewallResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SetPlanFirewallResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SetPlanFirewallResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SetPlanFirewallResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getPlan();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      accounts_protos_plan_dto_pb.PlanFirewallDTO.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 status_code = 1;
 * @return {number}
 */
proto.SetPlanFirewallResponse.prototype.getStatusCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.SetPlanFirewallResponse} returns this
 */
proto.SetPlanFirewallResponse.prototype.setStatusCode = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SetPlanFirewallResponse} returns this
 */
proto.SetPlanFirewallResponse.prototype.clearStatusCode = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SetPlanFirewallResponse.prototype.hasStatusCode = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PlanFirewallDTO plan = 2;
 * @return {?proto.PlanFirewallDTO}
 */
proto.SetPlanFirewallResponse.prototype.getPlan = function() {
  return /** @type{?proto.PlanFirewallDTO} */ (
    jspb.Message.getWrapperField(this, accounts_protos_plan_dto_pb.PlanFirewallDTO, 2));
};


/**
 * @param {?proto.PlanFirewallDTO|undefined} value
 * @return {!proto.SetPlanFirewallResponse} returns this
*/
proto.SetPlanFirewallResponse.prototype.setPlan = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SetPlanFirewallResponse} returns this
 */
proto.SetPlanFirewallResponse.prototype.clearPlan = function() {
  return this.setPlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SetPlanFirewallResponse.prototype.hasPlan = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DeleteSubscriptionFirewallRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.DeleteSubscriptionFirewallRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DeleteSubscriptionFirewallRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeleteSubscriptionFirewallRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    password: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DeleteSubscriptionFirewallRequest}
 */
proto.DeleteSubscriptionFirewallRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DeleteSubscriptionFirewallRequest;
  return proto.DeleteSubscriptionFirewallRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DeleteSubscriptionFirewallRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DeleteSubscriptionFirewallRequest}
 */
proto.DeleteSubscriptionFirewallRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DeleteSubscriptionFirewallRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DeleteSubscriptionFirewallRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DeleteSubscriptionFirewallRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeleteSubscriptionFirewallRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string password = 1;
 * @return {string}
 */
proto.DeleteSubscriptionFirewallRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.DeleteSubscriptionFirewallRequest} returns this
 */
proto.DeleteSubscriptionFirewallRequest.prototype.setPassword = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.DeleteSubscriptionFirewallRequest} returns this
 */
proto.DeleteSubscriptionFirewallRequest.prototype.clearPassword = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.DeleteSubscriptionFirewallRequest.prototype.hasPassword = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DeleteSubscriptionFirewallResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.DeleteSubscriptionFirewallResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DeleteSubscriptionFirewallResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeleteSubscriptionFirewallResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    statusCode: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    plan: (f = msg.getPlan()) && accounts_protos_plan_dto_pb.PlanFirewallDTO.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DeleteSubscriptionFirewallResponse}
 */
proto.DeleteSubscriptionFirewallResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DeleteSubscriptionFirewallResponse;
  return proto.DeleteSubscriptionFirewallResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DeleteSubscriptionFirewallResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DeleteSubscriptionFirewallResponse}
 */
proto.DeleteSubscriptionFirewallResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatusCode(value);
      break;
    case 2:
      var value = new accounts_protos_plan_dto_pb.PlanFirewallDTO;
      reader.readMessage(value,accounts_protos_plan_dto_pb.PlanFirewallDTO.deserializeBinaryFromReader);
      msg.setPlan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DeleteSubscriptionFirewallResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DeleteSubscriptionFirewallResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DeleteSubscriptionFirewallResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeleteSubscriptionFirewallResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getPlan();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      accounts_protos_plan_dto_pb.PlanFirewallDTO.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 status_code = 1;
 * @return {number}
 */
proto.DeleteSubscriptionFirewallResponse.prototype.getStatusCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.DeleteSubscriptionFirewallResponse} returns this
 */
proto.DeleteSubscriptionFirewallResponse.prototype.setStatusCode = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.DeleteSubscriptionFirewallResponse} returns this
 */
proto.DeleteSubscriptionFirewallResponse.prototype.clearStatusCode = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.DeleteSubscriptionFirewallResponse.prototype.hasStatusCode = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PlanFirewallDTO plan = 2;
 * @return {?proto.PlanFirewallDTO}
 */
proto.DeleteSubscriptionFirewallResponse.prototype.getPlan = function() {
  return /** @type{?proto.PlanFirewallDTO} */ (
    jspb.Message.getWrapperField(this, accounts_protos_plan_dto_pb.PlanFirewallDTO, 2));
};


/**
 * @param {?proto.PlanFirewallDTO|undefined} value
 * @return {!proto.DeleteSubscriptionFirewallResponse} returns this
*/
proto.DeleteSubscriptionFirewallResponse.prototype.setPlan = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.DeleteSubscriptionFirewallResponse} returns this
 */
proto.DeleteSubscriptionFirewallResponse.prototype.clearPlan = function() {
  return this.setPlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.DeleteSubscriptionFirewallResponse.prototype.hasPlan = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * @enum {number}
 */
proto.SetPlanFirewallRequestBackendType = {
  STRIPE: 1
};

goog.object.extend(exports, proto);
